const KEY = {
  KEY_GOOGLE: "61448175347-sdkc1ctm458r90il0ba4gule5a7t8pq7.apps.googleusercontent.com",
  KEY_FACEBOOK: "557816459623803"
}

export default KEY
